export const dispatchSearchRefreshEvent = (data) => {
  const searchRefreshEvent = new CustomEvent("beon.search.results.refresh", {
    detail: { data },
  });
  document.dispatchEvent(searchRefreshEvent);
};

export const dispatchSetupAnchorsEvent = (data) => {
  const setupAnchorsEvent = new CustomEvent("beon.search.setup.anchors", {
    detail: { data },
  });
  document.dispatchEvent(setupAnchorsEvent);
};

export const dispatchInputInitializedEvent = () => {
  const searchConfig = window.bn_config_search_page || {};
  const inputInitializedEvent = new CustomEvent(
    "beon.search.input.initialized",
    {
      detail: {
        data: {
          ...searchConfig,
        },
      },
    }
  );

  document.dispatchEvent(inputInitializedEvent);
};

export const dispatchGA4SearchEvent = ({
  eventAction,
  eventCount,
  eventLabel,
  eventValue,
  eventProducts,
}) => {
  const event = {
    event: "beonly_search",
    eventAction,
    eventLabel,
  };

  if (eventCount) {
    event.eventCount = eventCount;
  }

  if (eventValue) {
    event.eventValue = eventValue;
  }

  if (eventProducts) {
    const products = [];
    eventProducts.forEach(
      ({ details, name, sku, product_id, price_from, price_to, refid }) => {
        const product = {
          name,
          sku,
          product_id,
          price_to,
        };

        if (price_from) {
          product.price_from = price_from;
        }

        if (details?.brand) {
          product.brand = details.brand;
        }

        if (refid) {
          product.refid = refid;
        }

        products.push(product);
      }
    );

    event.products = products;
  }

  const dataLayer = window.dataLayer || [];
  const searchEvent = new CustomEvent("beonly_search", {
    detail: event,
  });

  dataLayer.push(event);
  document.dispatchEvent(searchEvent);
};

export const sendSelectItemEvent = ({ item }) => {
  try {
    const eventName = "bly_select_item";
    const listId = "[Bly][Busca] Resultados";
    const listName = `[Bly][Busca] ${decodeURIComponent(
      window.location.search.split("q=")?.[1]
    )}`;
    const productId = item?.product_id;
    const name = item?.name;
    const sku = item?.sku;
    const discount = item?.price_discount_value ?? undefined;
    const priceTo = item?.price_to;

    const eventData = {
      event: eventName,
      item_list_id: listId,
      item_list_name: listName,
      items: [
        {
          item_id: productId,
          item_name: name,
          discount,
          item_list_id: listId,
          item_list_name: listName,
          item_variant: sku,
          price: priceTo,
        },
      ],
    };

    const dataLayer = window.dataLayer || [];
    const event = new CustomEvent(eventName, {
      detail: eventData,
    });

    dataLayer.push(eventData);
    document.dispatchEvent(event);
  } catch (e) {
    console.warn("[Bnly-Search] Send select item event failed with", e);
  }
};

export const sendViewItemListEvent = ({ products }) => {
  try {
    const eventName = "bly_view_item_list";
    const listId = "[Bly][Busca] Resultados";
    const listName = `[Bly][Busca] ${decodeURIComponent(
      window.location.search.split("q=")?.[1]
    )}`;
    const items = products?.map((product, index) => {
      return {
        item_id: product?.product_id,
        item_name: product?.name,
        discount: product?.price_discount_value ?? undefined,
        index,

        item_list_id: listId,
        item_list_name: listName,
        item_variant: product?.sku,
        price: product?.price_to,
      };
    });

    const eventData = {
      event: eventName,
      item_list_id: listId,
      item_list_name: listName,
      items,
    };

    const dataLayer = window.dataLayer || [];
    const event = new CustomEvent(eventName, {
      detail: eventData,
    });

    dataLayer.push(eventData);
    document.dispatchEvent(event);
  } catch (e) {
    console.warn("[Bnly-Search] Send view item list event failed with", e);
  }
};
